function assertSameLength(v0: number[], v1: number[]) {
  if (v0.length !== v1.length) {
    throw new Error();
  }

  return v0.length;
}

function newArray(length: number): number[] {
  return Array(length).fill(0);
}

export class VectorMath {
  static add(v0: number[], v1: number[]): number[] {
    const length = assertSameLength(v0, v1);
    const result = Array(length).fill(0);
    for (let i = 0; i < length; i++) {
      result[i] = v0[i]! + v1[i]!;
    }
    return result;
  }

  static subtract(v0: number[], v1: number[]) {
    const length = assertSameLength(v0, v1);
    const result = newArray(length);
    for (let i = 0; i < length; i++) {
      result[i] = v0[i]! - v1[i]!;
    }
    return result;
  }

  static length(v: number[]) {
    let result = 0;
    for (let i = 0; i < v.length; i++) {
      result += Math.pow(v[i]!, 2);
    }
    return Math.sqrt(result);
  }

  static unit(v: number[]) {
    const l = VectorMath.length(v);
    const result = newArray(v.length);
    for (let i = 0; i < v.length; i++) {
      result[i] = v[i]! / l;
    }
    return result;
  }

  static multiply(v: number[], scale: number) {
    const result = newArray(v.length);
    for (let i = 0; i < result.length; i++) {
      result[i] = v[i]! * scale;
    }
    return result;
  }

  static rotate(v: number[], radians: number) {
    if (v.length !== 2) throw new Error();
    const x = v[0]!;
    const y = v[1]!;

    return [
      x * Math.cos(radians) - y * Math.sin(radians),
      x * Math.sin(radians) + y * Math.cos(radians),
    ];
  }

  static dot(v0: number[], v1: number[]) {
    const length = assertSameLength(v0, v1);
    let result = 0;
    for (let i = 0; i < length; i++) {
      result += v0[i]! * v1[i]!;
    }
    return result;
  }
}
